import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '../../../../shared/services/language.service';

@Component({
  selector: 'app-basic-search',
  templateUrl: './basic-search.component.html',
  styleUrls: ['./basic-search.component.css']
})
export class BasicSearchComponent implements OnInit {

  @Input() documentTypes: DocumentType[] = null;
  @Input() documentCategories: any;
  @Input() documentTypeSearchValue: string = "";
  @Input() documentCategorySearchValue: string = "";

  freeSearchValue: string = "";

  labels = {
    Search: this.languageService.LNG("Label.Search"),
    FreeTextSearch: this.languageService.LNG("Label.FreeTextSearch"),
    Category: this.languageService.LNG('Label.Category'),
    Type: this.languageService.LNG('Label.Type'),
    Close: this.languageService.LNG('Label.Close')
  }

  constructor(public languageService: LanguageService) { }

  ngOnInit(): void {
  }
}
